// 取整数
export function roundNumbers(val: string) {
  let str = val;
  if (typeof str === "string") {
    if (str.substring(str.length - 3, str.length) === ".00") {
      str = str.slice(0, str.length - 3);
    }
    if (str === "") {
      str = "0";
    }
    // 如果小于0;
    if (str !== "" && str.indexOf("-") !== -1) {
      str = str.slice(str.indexOf("-") + 1, str.length);
    }
  }
  return str;
}
